import { InferValueTypes } from '@quiz-frontend/quiz-builder/types/store-types';

import * as actions from './actions';

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface NotificationMessage {
  id: string;
  type: NotificationType;
  title: string;
  buttonTitle?: string;
  onClickButton?: () => void;
  onRemove?: () => void;
}

export enum NotificationAction {
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
  UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION',
}

export type NotificationActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export type NotificationState = Readonly<NotificationMessage[]>;
